"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
// Some resrources are associated with particular sessions
// The session bar filters resources based on tags (i.e. session1, session3, etc.)
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  var _super = _createSuper(Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentSession: 'All'
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.props.filterUpdater(_this.state.currentSession);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.filterUpdater('All');
    });
    _defineProperty(_assertThisInitialized(_this), "changeSession", function (e, session) {
      e && e.preventDefault();
      _this.props.filterUpdater(session);
      _this.setState({
        currentSession: session
      });
    });
    _defineProperty(_assertThisInitialized(_this), "getTagFromSession", function (session) {
      return _this.props.tags.filter(function (tag) {
        return tag.name === session;
      })[0];
    });
    _defineProperty(_assertThisInitialized(_this), "sessionsToTags", function () {
      var tagList = [];
      for (var i = 0; i < _this.props.topFilterBar.tags.length; i++) {
        var session = _this.props.topFilterBar.tags[i];
        tagList.push(_this.getTagFromSession(session));
      }
      return tagList;
    });
    return _this;
  }
  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var sessions = this.sessionsToTags();
      if (sessions.length < 1 || typeof this.props.topFilterBar.showTopFilterBar === 'boolean' && this.props.topFilterBar.showTopFilterBar === false // This key may not exist, so check if it exists and is false
      ) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-xs-12 text-center"
      }, /*#__PURE__*/_react["default"].createElement("nav", {
        "aria-label": "Session navigation"
      }, /*#__PURE__*/_react["default"].createElement("ul", {
        className: "pagination"
      }, this.props.topFilterBar.title && /*#__PURE__*/_react["default"].createElement("li", {
        className: "page-item disabled"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: _style["default"].label
      }, this.props.topFilterBar.title)), /*#__PURE__*/_react["default"].createElement("li", {
        className: this.state.currentSession === 'All' ? 'active' : ''
      }, /*#__PURE__*/_react["default"].createElement("a", {
        onClick: function onClick(e) {
          return _this2.changeSession(e, 'All');
        },
        href: "#",
        "aria-label": "All Sessions"
      }, "All", ' ')), sessions.map(function (session) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: _this2.state.currentSession === session.name ? 'active' : '',
          key: session.name
        }, /*#__PURE__*/_react["default"].createElement("a", {
          href: "#",
          onClick: function onClick(e) {
            return _this2.changeSession(e, session.name);
          }
        }, session.label));
      })))));
    }
  }]);
  return Component;
}(_react["default"].Component);
exports["default"] = Component;
_defineProperty(Component, "propTypes", {
  topFilterBar: _propTypes["default"].object.isRequired,
  tags: _propTypes["default"].array,
  filterUpdater: _propTypes["default"].func
});